import { post, get } from '../request'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import ApiResponse from '~/model/response'

export const addComment = (data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('comment/add', token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const deleteComment = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('comment/delete/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}
